import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb-vb',
  templateUrl: './breadcrumb-vb.component.html',
  styleUrls: ['./breadcrumb-vb.component.scss']
})
export class BreadcrumbVbComponent implements OnInit {

  @Input() menuItems = [];

  constructor() {}

  ngOnInit(): void {

  }

}
